import { Example } from "../models/ExampleModel";
import { ExplanationModel } from "../models/ExplanationModel";
import { VerbConjugation } from "../models/VerbConjugationModel";

export const preteritoIndefinidoExplanation: ExplanationModel = {
    title: "📖 What is Pretérito Indefinido?",
    description: "Used for actions that happened at a specific time in the past with no connection to the present.",
    bulletPoints: [
        "Describes completed past actions (e.g., 'Ayer fui al cine').",
        "Used with specific time expressions: ayer, anoche, la semana pasada, en 2010, hace un mes.",
        "Has regular conjugations, but many verbs are irregular and follow different patterns."
    ]
};

export const PreteritoIndefinidoExamplesData: Example[] = [
    {
        sentence: "Ayer fui al cine.",
        explanation: "🎬 Completed Action – 'Yesterday, I went to the cinema.' This sentence shows an event that happened at a specific time in the past and is completely finished."
    },
    {
        sentence: "El año pasado viajé a España.",
        explanation: "✈️ Specific Time Reference – 'Last year, I traveled to Spain.' The use of el año pasado (last year) indicates a finished event with no connection to the present."
    },
    {
        sentence: "Hicimos una fiesta el sábado pasado.",
        explanation: "🎉 One-Time Event – 'We had a party last Saturday.' The past event is clearly linked to a precise moment (el sábado pasado), making pretérito indefinido the correct tense."
    },
    {
        sentence: "¿Qué comiste ayer?",
        explanation: "🍽️ Past Question – 'What did you eat yesterday?' The verb comiste (you ate) is in pretérito indefinido because the action happened at a specific time (ayer)."
    }
]


export const preteritoIndefinidoRegular: VerbConjugation[] = [
    { verb: "Hablar", conjugations: ["hablé", "hablaste", "habló", "hablamos", "hablasteis", "hablaron"] },
    { verb: "Comer", conjugations: ["comí", "comiste", "comió", "comimos", "comisteis", "comieron"] },
    { verb: "Vivir", conjugations: ["viví", "viviste", "vivió", "vivimos", "vivisteis", "vivieron"] }
];

// Stem-Changing Verbs Explanation Data
export const preteritoIndefinidoStemChange: ExplanationModel = {
    title: "Stem-Changing Verbs",
    description: "Some -IR verbs change their root in the 3rd person singular and plural (él/ella/usted & ellos/ellas/ustedes).",
    bulletPoints: [
        "e → i: pedir → pedí, pediste, pidió, pedimos, pedisteis, pidieron",
        "e → i: sentir → sentí, sentiste, sintió, sentimos, sentisteis, sintieron",
        "o → u: dormir → dormí, dormiste, durmió, dormimos, dormisteis, durmieron"
    ]
};

// Strong Irregular Conjugations Data
export const preteritoIndefinidoStrongIrregulars: VerbConjugation[] = [
    { verb: "Hacer", conjugations: ["hice", "hiciste", "hizo", "hicimos", "hicisteis", "hicieron"] },
    { verb: "Tener", conjugations: ["tuve", "tuviste", "tuvo", "tuvimos", "tuvisteis", "tuvieron"] },
    { verb: "Estar", conjugations: ["estuve", "estuviste", "estuvo", "estuvimos", "estuvisteis", "estuvieron"] },
    { verb: "Poder", conjugations: ["pude", "pudiste", "pudo", "pudimos", "pudisteis", "pudieron"] },
    { verb: "Poner", conjugations: ["puse", "pusiste", "puso", "pusimos", "pusisteis", "pusieron"] },
    { verb: "Venir", conjugations: ["vine", "viniste", "vino", "vinimos", "vinisteis", "vinieron"] },
    { verb: "Saber", conjugations: ["supe", "supiste", "supo", "supimos", "supisteis", "supieron"] },
    { verb: "Querer", conjugations: ["quise", "quisiste", "quiso", "quisimos", "quisisteis", "quisieron"] }
];

// Complete Irregular Conjugations Data
export const preteritoIndefinidoCompleteIrregulars: VerbConjugation[] = [
    { verb: "Ser / Ir", conjugations: ["fui", "fuiste", "fue", "fuimos", "fuisteis", "fueron"] },
    { verb: "Dar", conjugations: ["di", "diste", "dio", "dimos", "disteis", "dieron"] },
    { verb: "Ver", conjugations: ["vi", "viste", "vio", "vimos", "visteis", "vieron"] }
];